import React from 'react';
import { v4 } from 'uuid';

import ErrorDialog from './ErrorDialog';
import * as logger from '../lib/logger';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    const [, errorCode] = v4().split('-');
    this.setState({ hasError: true, errorCode, error });
    logger.error(error, { ...info, errorCode });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <ErrorDialog
        errorCode={this.state.errorCode}
        error={this.state.error}
        onClose={() => this.setState({ hasError: false })}
      />
    );
  }
}
